import type { Channel, Program } from "@hybrid-iptv/types";

/**
 * What is on a channel now and next, for the remote's Info button in full
 * screen (owner, 2026-10-06: "program info ... only brings up the toolbars with
 * no info"). The guide holds the listings, so the Live page answers while it is
 * mounted; with no guide behind the player there is no answer.
 */
export interface NowInfo {
  channel: Channel;
  now: Program | null;
  next: Program | null;
}

type Lookup = (channelName: string) => NowInfo | null;
let lookup: Lookup | null = null;

/** The Live page registers its lookup; the returned function takes it away. */
export function provideNowInfo(fn: Lookup): () => void {
  lookup = fn;
  return () => {
    if (lookup === fn) lookup = null;
  };
}

export function nowInfoFor(channelName: string): NowInfo | null {
  return lookup ? lookup(channelName) : null;
}
